import React, { useState, useEffect } from "react";
import { View, Text, TextInput, StyleSheet, TouchableOpacity, Image, ScrollView, Modal, Dimensions } from "react-native";
import { BLACK_COLOR } from "../utils/theme";
import { ButtonComponent } from 'tutorapp-components';

// Get screen width for responsive design
const { width } = Dimensions.get('window');

const StudentFillDetails = ({ 
  icons, 
  handleStudentList, 
  handleBack,
  selectedstudent, 
  subjectlist, 
  handleselectionclose, 
  selectedFranchise, 
  onContinue, 
  getsubjectlisting,
  enData
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSubjectModalVisible, setIsSubjectModalVisible] = useState(false);
  const [selectedEnrollment, setSelectedEnrollment] = useState("Select Enrollment");
  const [selectedSubject, setSelectedSubject] = useState("Select Subject");
  const [remainingHour, setRemainingHour] = useState("0.00");

  // Reset and set default values for enrollment and subject when selectedstudent or subjectlist changes
  useEffect(() => {
    // Reset to default
    setSelectedEnrollment("Select Enrollment");
    setSelectedSubject("Select Subject");
    setRemainingHour("0.00");


    // If only one enrollment exists, set it as default
    if (selectedstudent?.enrollment?.length === 1) {
      setSelectedEnrollment(selectedstudent.enrollment[0].name);
      handleEnrollmentSelect(selectedstudent.enrollment[0]);
    }
  }, [selectedstudent]);

  useEffect(() => {
    
    // If only one subject exists, set it as default
    if (subjectlist?.length === 1) {
      setSelectedSubject(subjectlist[0].name);
      setSelectSubjectData(subjectlist[0]);
      setRemainingHour(subjectlist[0]?.remaining.toFixed(2) || '0.00');
    }
  }, [subjectlist]);

  const handleEnrollmentSelect = (enrollment) => {
    setSelectedEnrollment(enrollment.name);
    getsubjectlisting(enrollment.id, selectedFranchise, selectedstudent);
    setIsModalVisible(false);
  };

  const handleSubjectSelect = (subject) => {
    setSelectedSubject(subject.name);
    setSelectSubjectData(subject);
    setIsSubjectModalVisible(false);
    setRemainingHour(subject?.remaining.toFixed(2) || '0.00');
  };

  //set selected subject data
  const [selectedSubjectData, setSelectSubjectData] = useState();
  const handleContinue = () => {
    if (!selectedstudent || !subjectlist || subjectlist.length === 0 || selectedSubjectData?.remaining == 0 || selectedSubjectData?.remaining < 0) {
      return;
    }
    
    const formattedData = {
      tutor_id: selectedFranchise.tutor_id,
      franchise_id: selectedFranchise.franchise_id,
      student_id: selectedstudent.id,
      enrollment_id: enData?.id,
      subject_id: selectedSubjectData.id,
      tutor_address: selectedstudent.tutor_address,
      session_per_week: selectedSubjectData.sessions_per_week,
      allocation: enData?.allocation,
      remaining_hour: remainingHour,
      display_repeat: enData?.is_display_repeat
    };

    onContinue({
      formattedData,
      sessionPerWeek: selectedSubjectData.sessions_per_week,
      subjectId: selectedSubjectData.id
    });
  };

  const isContinueDisabled = 
    !selectedstudent || 
    !subjectlist || 
    subjectlist.length === 0 || 
    remainingHour == 0 || 
    remainingHour < 0 || 
    selectedEnrollment === "Select Enrollment" || 
    selectedSubject === "Select Subject";
  
  return (
    <View style={styles.mainContainer} testID="general-appointment-container">
      <View style={styles.container} testID="session-report-container">
        <View style={styles.header} testID="header">
          <TouchableOpacity style={styles.iconButton} testID="session-appointment-icon">
            <Image source={{ uri: icons.sessionappointment }} style={styles.progressIcon} />
          </TouchableOpacity>
          <Text style={styles.title} testID="session-report-title">CREATE APPOINTMENT</Text>
          <TouchableOpacity onPress={handleselectionclose} style={styles.iconButton} testID="close-button">
            <Image source={{ uri: icons.close }} style={styles.progressIcon} />
          </TouchableOpacity>
        </View>

        <View style={styles.sessionCard} testID="session-info-card">
          <Text style={styles.sessionText} testID="about-session-text">FILL DETAILS</Text>
          <View style={styles.progressContainer} testID="session-progress">
            <Text style={styles.progressText} testID="session-progress-count">2</Text>
            <Text style={styles.totalText} testID="total-sessions">/4</Text>
            <Image source={{ uri: icons.progress }} style={styles.progressIcon} />
          </View>
        </View>
      </View>

      <ScrollView contentContainerStyle={styles.scrollContent} testID="scroll-content">
        <View style={styles.formContainer} testID="form-container">
          <TouchableOpacity
            onPress={handleStudentList}
            testID="student-field"
            style={styles.fieldContainer}
          >
            <Field
              label="Student"
              value={selectedstudent?.name || "Select Student"}
              leftIcon={icons.studentIcon}
              rightIcon={icons.rightchevron}
              testID="field-student"
            />
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => setIsModalVisible(true)}
            testID="enrollment-field"
            style={styles.fieldContainer}
          >
            <Field
              label="Enrollment"
              value={selectedEnrollment}
              leftIcon={icons.enrollmentIcon}
              rightIcon={icons.rightchevron}
              testID="field-enrollment"
            />
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => setIsSubjectModalVisible(true)}
            testID="subject-field"
            style={styles.fieldContainer}
          >
            <Field
              label="Subject"
              value={selectedSubject}
              leftIcon={icons.subjectIcon}
              rightIcon={icons.rightchevron}
              testID="field-subject"
            />
          </TouchableOpacity>

          <Field
            label="Remaining Hours"
            value={remainingHour || '0.00'}
            leftIcon={icons.hoursIcon}
            testID="field-hours"
            style={{ backgroundColor: "#D3D3D3" }}
          />
        </View>

        <View style={styles.buttonContainer}>
          <View style={styles.buttonWrapper}>
            <ButtonComponent
              onPress={isContinueDisabled ? null : handleContinue}
              label="Continue"
              disabled={isContinueDisabled}
              style={{
                backgroundColor: isContinueDisabled ? '#ccc' : BLACK_COLOR,
                paddingVertical: 12,
                fontFamily: 'GT-Walsheim',
                pointerEvents: isContinueDisabled ? 'none' : 'auto',
              }}
              textStyle={{
                color: isContinueDisabled ? '#666' : 'white',
                fontFamily: 'GT-Walsheim',
              }}
            />
          </View>
          <View style={styles.buttonWrapper}>
            <ButtonComponent
              onPress={handleBack}
              label="Back"
              style={{ backgroundColor: '#E9EDF1', paddingVertical: 12, fontFamily: 'GT-Walsheim' }}
              textStyle={{ color: '#000', fontFamily: 'GT-Walsheim' }}
            />
          </View>
        </View>
      </ScrollView>

      <Modal
        visible={isModalVisible}
        transparent={true}
        animationType="slide"
        onRequestClose={() => setIsModalVisible(false)}
        testID="enrollment-modal"
      >
        <View style={styles.modalOverlay} testID="modal-overlay">
          <View style={styles.modalContent} testID="modal-content">
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle} testID="modal-title">Select Enrollment</Text>
              <TouchableOpacity onPress={() => setIsModalVisible(false)} testID="modal-close-button">
                <Image source={{ uri: icons.close }} style={styles.modalCloseIcon} />
              </TouchableOpacity>
            </View>
            <ScrollView testID="modal-scroll-content">
              {selectedstudent?.enrollment?.map((enrollment) => (
                <TouchableOpacity
                  key={enrollment.id}
                  style={styles.enrollmentItem}
                  onPress={() => handleEnrollmentSelect(enrollment)}
                  testID={`enrollment-item-${enrollment.id}`}
                >
                  <Text style={styles.enrollmentText} testID={`enrollment-text-${enrollment.id}`}>
                    {enrollment.name}
                  </Text>
                </TouchableOpacity>
              ))}
            </ScrollView>
          </View>
        </View>
      </Modal>

      <Modal
        visible={isSubjectModalVisible}
        transparent={true}
        animationType="slide"
        onRequestClose={() => setIsSubjectModalVisible(false)}
        testID="subject-modal"
      >
        <View style={styles.modalOverlay} testID="subject-modal-overlay">
          <View style={styles.modalContent} testID="subject-modal-content">
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle} testID="subject-modal-title">Select Subject</Text>
              <TouchableOpacity onPress={() => setIsSubjectModalVisible(false)} testID="subject-modal-close-button">
                <Image source={{ uri: icons.close }} style={styles.modalCloseIcon} />
              </TouchableOpacity>
            </View>
            <ScrollView testID="subject-modal-scroll-content">
              {subjectlist?.map((subject) => (
                <TouchableOpacity
                  key={subject.id}
                  style={styles.enrollmentItem}
                  onPress={() => handleSubjectSelect(subject)}
                  testID={`subject-item-${subject.id}`}
                >
                  <Text style={styles.enrollmentText} testID={`subject-text-${subject.id}`}>
                    {subject.name}
                  </Text>
                </TouchableOpacity>
              ))}
            </ScrollView>
          </View>
        </View>
      </Modal>
    </View>
  );
};

const Field = ({ label, value, isInput, leftIcon, rightIcon, testID, style }) => (
  <View style={styles.fieldContainer} testID={testID}>
    <Text style={styles.label} testID={`${testID}-label`}>{label}</Text>
    <View
      style={[styles.inputContainer, style]}
      testID={`${testID}-input-container`}
    >
      {leftIcon && <Image source={{ uri: leftIcon }} style={styles.icon} testID={`${testID}-left-icon`} />}
      {isInput ? (
        <TextInput style={styles.input} value={value} testID={`${testID}-input`} />
      ) : (
        <View style={styles.selectableField} testID={`${testID}-selectable-field`}>
          <Text style={styles.selectableText} testID={`${testID}-selectable-text`}>{value}</Text>
        </View>
      )}
      {rightIcon && <Image source={{ uri: rightIcon }} style={styles.rightIcon} testID={`${testID}-right-icon`} />}
    </View>
  </View>
);

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: "#F5F7FA",
    fontFamily: "GT-Walsheim",
  },
  container: {
    width: '100%',
    backgroundColor: "#0E1525",
    paddingHorizontal: 20,
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    fontFamily: "GT-Walsheim",
    paddingVertical: 10,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: '100%',
    fontFamily: "GT-Walsheim",
  },
  iconButton: {
    backgroundColor: "#2C2F38",
    padding: 5,
    borderRadius: 8,
    fontFamily: "GT-Walsheim",
  },
  icon: {
    width: 28,
    height: 28,
    resizeMode: "contain",
  },
  title: {
    color: "white",
    fontSize: 17,
    flex: 1,
    textAlign: "center",
    fontFamily: "GT-Walsheim-Bold",
  },
  sessionCard: {
    backgroundColor: "#2C2F38",
    padding: 9,
    borderRadius: 8,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginVertical: 10,
    fontFamily: "GT-Walsheim",
  },
  sessionText: {
    color: "white",
    fontFamily: "GT-Walsheim-Bold",
    fontSize: 12,
  },
  progressContainer: {
    flexDirection: "row",
    alignItems: "center",
    fontFamily: "GT-Walsheim",
  },
  progressText: {
    color: "white",
    fontSize: 14,
    fontFamily: "GT-Walsheim-Bold",
  },
  totalText: {
    color: "gray",
    fontSize: 14,
    fontFamily: "GT-Walsheim-Bold",
  },
  progressIcon: {
    width: 30,
    height: 30,
    marginLeft: 5,
    resizeMode: "contain",
    fontFamily: "GT-Walsheim",
  },
  scrollContent: {
    flexGrow: 1,
    alignItems: 'center',
    paddingBottom: 20,
    fontFamily: "GT-Walsheim",
  },
  formContainer: {
    paddingVertical: 12,
    borderRadius: 10,
    elevation: 2,
    marginTop: 20,
    fontFamily: "GT-Walsheim",
  },
  fieldContainer: {
    width: 320,
    paddingBottom: 8,
    fontFamily: "GT-Walsheim",
  },
  label: {
    fontSize: 15,
    color: BLACK_COLOR,
    paddingBottom: 4,
    fontFamily: "GT-Walsheim-Medium",
  },
  inputContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: 7,
    borderWidth: 1,
    borderColor: "#ddd",
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  icon: {
    width: 25,
    height: 25,
    resizeMode: "contain",
    marginRight: 10,
    fontFamily: "GT-Walsheim",
  },
  rightIcon: {
    width: 25,
    height: 25,
    resizeMode: "contain",
    marginLeft: 10,
  },
  selectableField: {
    flex: 1,
    fontFamily: "GT-Walsheim",
  },
  selectableText: {
    fontSize: 16,
    color: "#333",
    fontFamily: "GT-Walsheim",
  },
  input: {
    flex: 1,
    color: BLACK_COLOR,
    fontSize: 14,
    fontFamily: "GT-Walsheim",
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.5)",
    justifyContent: "flex-end",
  },
  modalContent: {
    backgroundColor: "#fff",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    padding: 20,
    maxHeight: "50%",
    width: width,
    alignSelf: 'center',
  },
  modalHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  modalTitle: {
    fontSize: 18,
    fontFamily: "GT-Walsheim-Bold",
    color: BLACK_COLOR,
  },
  modalCloseIcon: {
    width: 24,
    height: 24,
    resizeMode: "contain",
  },
  enrollmentItem: {
    paddingVertical: 15,
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
  },
  enrollmentText: {
    fontSize: 16,
    fontFamily: "GT-Walsheim",
    color: "#333",
  },
  buttonContainer: {
    alignSelf: 'center',
    marginTop: 20,
    fontFamily: "GT-Walsheim",
  },
  buttonWrapper: {
    width: 320,
    marginBottom: 10,
    fontFamily: "GT-Walsheim",
  },
});

export default StudentFillDetails;